<template>
    <div class="order-products-list">
        <h3 class="mb-1">Orden</h3>
        <table class="table border site-block-order-table my-2 text-left">
            <thead>
            <th>Producto</th>
            <th>Total</th>
            </thead>
            <tbody>
            <tr v-for="product in products">
                <td>
                    {{ product.item_name }}<strong class="mx-2">x</strong>
                    {{ product.quantity }}
                    <ul
                        class="list-group list-group-flush"
                        v-if="product.delight"
                    >
                        <li class="list-group-item">
                            {{ product.delight.description }} ({{
                                product.quantity
                            }})
                        </li>
                    </ul>
                </td>
                <td>${{ product.price * product.quantity }}</td>
            </tr>
            <tr v-if="sent_cost">
                <td class="text-black font-weight-bold">
                    <strong>Costo de envío</strong>
                </td>
                <td class="text-black font-weight-bold">
                    <strong>${{ sending_cost }}</strong>
                </td>
            </tr>
            <tr v-if="sent_cost">
                <td class="text-black font-weight-bold">
                    <strong>Orden Total</strong>
                </td>
                <td class="text-black font-weight-bold">
                    <strong>${{ parseFloat(total) + parseFloat(sending_cost) }}</strong>
                </td>
            </tr>
            <tr v-else>
                <td class="text-black font-weight-bold">
                    <strong>Orden Total</strong>
                </td>
                <td class="text-black font-weight-bold">
                    <strong>${{ total }}</strong>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from "axios";
import { eventBus } from "./../../events.js";


export default {
    name: "ProductCheckoutList",
    data() {
        return {
            api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
            base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
            local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
            sent_cost: false,
            sending_cost: 0,
            subtotal: 0,
            total: 0,
            iva: 0,
            products: [],
        }
    },
    mounted() {
        console.log('montando suscripciones');
        this.products = this.$store.state.cartSubscription;
        console.log('toma el store de suscripciones');
        console.log("Checar costo de envio");
        this.updateOrder();
        this.getFee();
    },
    methods: {
        updateOrder: function(){
            var suma = 0;
            var tiene_costo = false;
            this.products.forEach(function (item) {
                suma += item.quantity * item.price;

                if (item.type_id === 2 || item.type_id === 3) {
                    tiene_costo = false;
                } else {
                    tiene_costo = true;
                }
            });
            this.subtotal = suma;
            this.total = this.subtotal;
        },
        getFee: function(){
            axios({
                method: "POST",
                url: this.api_url + "/shipping-fee/verify",
                data: {
                    items: this.products,
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + $cookies.get("ctoken"),
                },
            }).then((response) => {
                console.log("El costo de envio");
                console.log(response.data.fee);

                if (response.data.fee > 0) {
                    this.sent_cost = true;
                    this.sending_cost = response.data.fee;
                }
            }).catch((error) => {
                console.error(error);
            });
        }
    }
}
</script>

<style scoped>

</style>